<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ data.titulo }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content style="margin: 1.5em 0; max-height: 65vh; overflow: auto">
    <p class="descripcion">{{ data.descripcion }}</p>

    <div class="fila" *ngFor="let fila of data.filas">
      <div class="fila-encabezado">
        <strong>{{ fila.titulo }}</strong>
        <span class="conteo" *ngIf="fila.vecinosVigentes">
          {{ fila.vecinosVigentes }} vecino(s) con esta categoría vigente
        </span>
        <span class="conteo sin-vecinos" *ngIf="!fila.vecinosVigentes">
          sin vecinos con la categoría vigente
        </span>
      </div>

      <p class="nota" *ngIf="fila.nota">{{ fila.nota }}</p>

      <!-- Sin otra categoría asignada no hay a dónde mandar a los vecinos. -->
      <p class="sin-salida" *ngIf="sinSalida(fila)">
        Este cliente no tiene ninguna otra categoría asignada. Asignale otra
        antes de sacar ésta, si no sus vecinos se quedan sin poder emitir
        alertas.
      </p>

      <mat-form-field
        appearance="outline"
        class="selector"
        *ngIf="requiereEleccion(fila) && !sinSalida(fila)"
      >
        <mat-label>Mover los vecinos a</mat-label>
        <mat-select
          [value]="elegido.get(fila.clave)"
          (valueChange)="seleccionar(fila.clave, $event)"
        >
          <mat-option
            *ngFor="let opcion of fila.opciones"
            [value]="opcion.idCategoria"
          >
            {{ opcion.nombre }}
            <ng-container *ngIf="opcion.variante">
              / {{ opcion.variante }}
            </ng-container>
          </mat-option>
          <mat-option [value]="null">
            Ninguna — usan la categoría por defecto del cliente
          </mat-option>
        </mat-select>
      </mat-form-field>

      <p class="nota" *ngIf="!requiereEleccion(fila)">
        No hace falta elegir reemplazo: las referencias que queden se limpian
        solas.
      </p>
    </div>
  </mat-card-content>

  <mat-divider />

  <mat-card-actions class="gap-3" style="margin: 0.5em">
    <button
      mat-raised-button
      color="warn"
      [disabled]="!puedeConfirmar"
      (click)="confirmar()"
    >
      {{ data.textoConfirmar }}
    </button>
    <button mat-raised-button (click)="cancelar()">Cancelar</button>
  </mat-card-actions>
</mat-card>
